import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pinterest",
  "use": "pinterest-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"pinterest\"><path d=\"M475 256c0 40-9 77-29 110-20 34-46 60-80 80-33 20-70 29-110 29-21 0-42-3-62-9 11-17 18-33 22-47 2-6 7-26 15-60 4 8 11 14 21 19 10 6 21 9 33 9 23 0 43-7 62-20 18-13 32-31 42-54 9-23 14-48 14-77 0-22-5-42-17-61-11-19-27-35-49-47-21-12-46-18-73-18-20 0-38 3-56 9-17 5-32 12-44 22-12 9-22 19-31 31s-15 24-19 37-6 26-6 38c0 20 4 38 11 53 8 15 19 25 34 31 5 3 9 1 10-5 1-2 2-5 3-9 1-5 2-8 2-9 1-4 0-8-3-12-10-12-15-26-15-43 0-29 10-54 30-74 20-21 46-31 78-31 29 0 51 8 68 23 16 16 24 36 24 61 0 32-7 60-20 83-13 22-30 34-50 34-12 0-21-5-28-13s-9-18-7-30c2-6 4-15 8-26 4-12 6-21 9-30 2-8 3-16 3-21 0-10-3-18-8-24s-12-10-22-10c-12 0-22 6-30 17s-12 24-12 40c0 14 2 26 7 35l-28 120c-4 13-5 30-4 50-39-17-71-44-95-80s-36-77-36-121c0-40 9-77 29-110 20-34 46-60 80-80 33-20 70-29 110-29s77 9 110 29c34 20 60 46 80 80 20 33 29 70 29 110z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pinterest.svg
// module id = 198
// module chunks = 0